import api from '../../../config/axios-interceptor';

export const fetchOperators = async (page = 0, pageSize = 10, filters = {}) => {
    try {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('size', pageSize.toString());
        params.append('sort', 'createdAt,desc');

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, value);
            }
        });

        return await api.get(`/api/v1/operator/find-all?${params.toString()}`);
    } catch (error) {
        console.error('Error fetching operators:', error);
        throw error;
    }
};

export const fetchOperatorById = async (id) => {
    try {
        return await api.get(`/api/v1/operator/find/${id}`);
    } catch (error) {
        console.error('Error fetching operator by ID:', error);
        throw error;
    }
};

export const createOperator = async (operatorData) => {
    try {
        return await api.post('/api/v1/operator/create', operatorData);
    } catch (error) {
        console.error('Error creating operator:', error);
        throw error;
    }
};

export const updateOperator = async (operatorData) => {
    try {
        return await api.put('/api/v1/operator/update', operatorData);
    } catch (error) {
        console.error('Error updating operator:', error);
        throw error;
    }
};

/**
 * Set an operator's sign-in password, as an admin.
 *
 * Its own endpoint rather than a field on /update, because /update is reachable by operators for
 * self-service — a password field there would let one operator take over another's account.
 */
export const setOperatorPassword = async (id, newPassword) => {
    try {
        return await api.put(`/api/v1/operator/${id}/password`, {newPassword});
    } catch (error) {
        // Deliberately not logging the error object: the request body it carries is the password.
        console.error('Error setting operator password');
        throw error;
    }
};

export const deleteOperator = async (id) => {
    try {
        return await api.delete(`/api/v1/operator/delete/${id}`);
    } catch (error) {
        console.error('Error deleting operator:', error);
        throw error;
    }
};

/* ------------------------------------------------------------------ supervisors
 *
 * A supervisor is not an operator with extra rights — it is a different kind of account, with no
 * profile row, no shift and no caseload, so it has its own endpoints rather than a role dropdown on
 * the operator form. Giving one a shift would put them back in the assignment rota, which is the one
 * thing the role must not do.
 *
 * Note the direction: a supervisor SETS other operators' shifts (see ../shifts/shifts-api.js) while
 * having none of their own. Managing the rota and standing in it are different things.
 */
export const fetchSupervisors = async () => {
    try {
        return await api.get('/api/v1/supervisor/find-all');
    } catch (error) {
        console.error('Error fetching supervisors:', error);
        throw error;
    }
};

export const createSupervisor = async (payload) => {
    try {
        return await api.post('/api/v1/supervisor/create', payload);
    } catch (error) {
        // Not logging the error object: it carries the request body, which holds the password.
        console.error('Error creating supervisor');
        throw error;
    }
};

export const setSupervisorPassword = async (id, newPassword) => {
    try {
        return await api.put(`/api/v1/supervisor/${id}/password`, {newPassword});
    } catch (error) {
        console.error('Error setting supervisor password');
        throw error;
    }
};

export const deleteSupervisor = async (id) => {
    try {
        return await api.delete(`/api/v1/supervisor/delete/${id}`);
    } catch (error) {
        console.error('Error deleting supervisor:', error);
        throw error;
    }
};
